import { render, staticRenderFns } from "./similarProps.vue?vue&type=template&id=38818bfc&scoped=true&"
import script from "./similarProps.vue?vue&type=script&lang=js&"
export * from "./similarProps.vue?vue&type=script&lang=js&"
import style0 from "./similarProps.vue?vue&type=style&index=0&id=38818bfc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38818bfc",
  null
  
)

export default component.exports